var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "_ngcontent-rdh-c88": "",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "_ngcontent-rdh-c88": "",
    clipPath: "url(#clip0_3466_6422)"
  }, /*#__PURE__*/React.createElement("path", {
    "_ngcontent-rdh-c88": "",
    d: "M7.69284 9.61632H6.45233C5.57472 9.61632 4.85547 8.92767 4.85547 8.07915C4.85547 7.82705 5.07982 7.618 5.35036 7.618C5.6209 7.618 5.84525 7.82705 5.84525 8.07915C5.84525 8.41733 6.1158 8.69402 6.45233 8.69402H7.69284C7.95018 8.69402 8.15475 8.47881 8.15475 8.21442C8.15475 7.88239 8.05578 7.8332 7.83142 7.75941L5.84525 7.1138C5.42294 6.97853 4.85547 6.68955 4.85547 5.78569C4.85547 5.0171 5.50873 4.38379 6.30716 4.38379H7.54767C8.42528 4.38379 9.14453 5.07244 9.14453 5.92096C9.14453 6.17306 8.92018 6.38211 8.64964 6.38211C8.3791 6.38211 8.15475 6.17306 8.15475 5.92096C8.15475 5.58278 7.8842 5.30609 7.54767 5.30609H6.30716C6.04982 5.30609 5.84525 5.5213 5.84525 5.78569C5.84525 6.11772 5.94422 6.1669 6.16858 6.24069L8.15475 6.8863C8.57706 7.02157 9.14453 7.31056 9.14453 8.21442C9.14453 8.98915 8.49127 9.61632 7.69284 9.61632Z",
    fill: "#013d50"
  }), /*#__PURE__*/React.createElement("path", {
    "_ngcontent-rdh-c88": "",
    d: "M7 14C3.1386 14 0 10.8614 0 7C0 3.1386 3.1386 0 7 0C7.26698 0 7.48837 0.221395 7.48837 0.488372C7.48837 0.755349 7.26698 0.976744 7 0.976744C3.67907 0.976744 0.976744 3.67907 0.976744 7C0.976744 10.3209 3.67907 13.0233 7 13.0233C10.3209 13.0233 13.0233 10.3209 13.0233 7C13.0233 6.73302 13.2447 6.51163 13.5116 6.51163C13.7786 6.51163 14 6.73302 14 7C14 10.8614 10.8614 14 7 14Z",
    fill: "#013d50"
  }), /*#__PURE__*/React.createElement("path", {
    "_ngcontent-rdh-c88": "",
    d: "M12.8155 4.38428H10.188C9.91865 4.38428 9.69531 4.16094 9.69531 3.89162V1.26414C9.69531 0.994821 9.91865 0.771484 10.188 0.771484C10.4573 0.771484 10.6806 0.994821 10.6806 1.26414V3.39897H12.8155C13.0848 3.39897 13.3081 3.62231 13.3081 3.89162C13.3081 4.16094 13.0848 4.38428 12.8155 4.38428Z",
    fill: "#013d50"
  }), /*#__PURE__*/React.createElement("path", {
    "_ngcontent-rdh-c88": "",
    d: "M10.3176 4.31868C10.1714 4.31868 10.0251 4.26481 9.90962 4.14938C9.68638 3.92622 9.68638 3.55685 9.90962 3.33368L13.0171 0.167372C13.2404 -0.0557907 13.6099 -0.0557907 13.8331 0.167372C14.0564 0.390535 14.0564 0.759906 13.8331 0.983069L10.7256 4.14938C10.6102 4.26481 10.4639 4.31868 10.3176 4.31868Z",
    fill: "#013d50"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    "_ngcontent-rdh-c88": ""
  }, /*#__PURE__*/React.createElement("clipPath", {
    "_ngcontent-rdh-c88": "",
    id: "clip0_3466_6422"
  }, /*#__PURE__*/React.createElement("rect", {
    "_ngcontent-rdh-c88": "",
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommision);
export default __webpack_public_path__ + "static/media/commision.5a26d75142d6e697d15ffcfd7c1902ba.svg";
export { ForwardRef as ReactComponent };